export enum CoverType {
  Gold = 'G-STD',
  MultiPlan = 'MP',
  OneOffRepair = 'OOR',
  Platinum = 'P-STD',
  Silver = 'S-STD',
  SilverPlus = 'SP-STD',
  Standard = 'STD',
}
